import getters from '@/store/modules/scroll/getters'
import mutations from '@/store/modules/scroll/mutations'

export const state = {
  position: {
    left: 0,
    top: 0
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
